import { useSelector, useDispatch } from 'react-redux'
import { t } from '../../utils/i18n'
import Popover from '../Popover'
import { bikeImageReload, optionClicked } from '../../actions'
import { getChoice } from '../../utils/bike-config'
import { BACKEND_URL } from '../../utils/settings'

const CompatibilityPopover = () => {
  const dispatch = useDispatch()
  const {
    bikeConfig,
    options: { componentId }
  } = useSelector((state) => state)
  const {
    option: { compatible }
  } = getChoice(bikeConfig, componentId)

  const handleClick = (scenario) => {
    for (const [component, choice] of scenario) {
      dispatch(optionClicked(component, choice))
      dispatch(bikeImageReload())
    }
  }

  return (
    <Popover
      className="velorbis-customizer-gallery-popover compatibility-popover"
      alignTo={'.velorbis-customizer-header-tool-inner'}
      position="below"
      width={'375px'}
      preventClose
    >
      <div className="velorbis-customizer-popover-header">
        {t(compatible.heading)}
      </div>
      <div className="velorbis-customizer-popover-body">
        {compatible.accept[0][0] !== 'gear' && (
          <div>
            <img
              className="velorbis-customizer-hover-popover-image compatible-image"
              src={`${BACKEND_URL}/images/thumbnails/${compatible.accept[0][0]}/${compatible.accept[0][1]}.png`}
              alt={compatible.accept[0][0]}
            />
          </div>
        )}
        {t(compatible.text)}
        <div className="velorbis-customizer-toggleable-buttons compatibility-buttons">
          {!compatible.accept_primary ? (
            <button
              onClick={() => handleClick(compatible.accept)}
              className="velorbis-customizer-toggleable-on"
            >
              {t('yes_button')}
            </button>
          ) : (
            <button
              onClick={() => handleClick(compatible.accept_primary)}
              className="velorbis-customizer-toggleable-black"
            >
              {compatible.accept_primary_text
                ? t(compatible.accept_primary_text)
                : t('color_black')}
            </button>
          )}
          {compatible.accept_secondary && (
            <button
              onClick={() => handleClick(compatible.accept_secondary)}
              className="velorbis-customizer-toggleable-cream"
            >
              {compatible.accept_secondary_text
                ? t(compatible.accept_secondary_text)
                : t('color_cream')}
            </button>
          )}

          <button
            className="velorbis-customizer-toggleable-off"
            onClick={() => handleClick(compatible.reject)}
          >
            {t('no_button')}
          </button>
        </div>
      </div>
    </Popover>
  )
}

export default CompatibilityPopover
